'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform: translateY(0) translateX(-50%);\n  }\n  50% {\n    transform: translateY(-50%) translateX(-50%);\n  }\n  100% {\n    transform: translateY(0) translateX(-50%);\n  }\n'], ['\n  0% {\n    transform: translateY(0) translateX(-50%);\n  }\n  50% {\n    transform: translateY(-50%) translateX(-50%);\n  }\n  100% {\n    transform: translateY(0) translateX(-50%);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  animation: ', ' 1s ease infinite;\n  color: inherit;\n'], ['\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  animation: ', ' 1s ease infinite;\n  color: inherit;\n']);

var _rebass = require('rebass');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounce = (0, _styledComponents.keyframes)(_templateObject);

// Add custom styles here
var LaScrollDownIndicatorptop = (0, _styledComponents2.default)(_rebass.Button)(_templateObject2, bounce);

LaScrollDownIndicatorptop.displayName = 'LaScrollDownIndicatorptop';
LaScrollDownIndicatorptop.defaultProps = {
  children: '╲╱',
  bg: 'transparent'
};

exports.default = LaScrollDownIndicatorptop;